import Icon from "@core-components/icon/Icon";
import { Button } from "@mantine/core";

const HelpCenterReadMoreButton: React.FC = () => {
  return (
    <Button
      variant="transparent"
      className="font-inter text-base text-primary-white"
      leftSection={<Icon.Book size={20} />}
      title="En savoir plus"
    >
      En savoir plus
    </Button>
  );
};

export default HelpCenterReadMoreButton;
